import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  link: string;
}

const Button: React.FC<ButtonProps> = ({ children, onClick, className = '', link = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-400 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75 transition ease-in-out duration-300 ${className}`}
    >
      <a
        className="p-2"
        href={link}
        target="_blank"
        rel="noopener noreferrer" // It's good practice for security reasons when opening a link in a new tab.
      >
        {children}
      </a>
    </button>
  );
};

export default Button;
